import React, { useState } from 'react';
import './OrderAddressModal.css';

function OrderAddressModal({ isOpen, onClose, onSubmit, selectedItems, totalPrice }) {
  const [formData, setFormData] = useState({
    recipientName: '',
    phone: '',
    address: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.recipientName.trim()) {
      newErrors.recipientName = '请输入收货人姓名';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = '请输入手机号码';
    } else if (!/^\d{11}$/.test(formData.phone.trim())) {
      newErrors.phone = '手机号必须是11位数字';
    }

    if (!formData.address.trim()) {
      newErrors.address = '请输入详细地址';
    } else if (formData.address.trim().length < 10) {
      newErrors.address = '详细地址至少需要10个字符';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const orderData = {
      address: `${formData.recipientName}, ${formData.phone}, ${formData.address}`,
      items: selectedItems,
      totalPrice: totalPrice
    };

    onSubmit(orderData);
    
    setFormData({ recipientName: '', phone: '', address: '' });
    setErrors({});
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="address-overlay" onClick={onClose} />
      <div className="address-modal">
        <div className="modal-header">
          <h3>填写收货信息</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {selectedItems && selectedItems.length > 0 && (
          <div className="order-summary">
            <h4>📦 订单摘要</h4>
            <div className="summary-items">
              {selectedItems.map(item => (
                <div key={item.id} className="summary-item">
                  <span>{item.name} × {item.quantity}</span>
                  <span>{(item.price * item.quantity).toFixed(2)} 元宝</span>
                </div>
              ))}
            </div>
            <div className="summary-total">
              合计：<strong>{totalPrice.toFixed(2)} 元宝</strong>
            </div>
          </div>
        )}

        <form className="address-form" onSubmit={handleSubmit}>
          <div className={`form-group ${errors.recipientName ? 'has-error' : ''}`}>
            <label htmlFor="recipientName">
              收货人姓名 <span className="required">*</span>
            </label>
            <input
              type="text"
              id="recipientName"
              name="recipientName"
              placeholder="请输入收货人姓名"
              value={formData.recipientName}
              onChange={handleChange}
              maxLength={20}
            />
            {errors.recipientName && (
              <span className="error-msg">{errors.recipientName}</span>
            )}
          </div>

          <div className={`form-group ${errors.phone ? 'has-error' : ''}`}>
            <label htmlFor="phone">
              手机号码 <span className="required">*</span>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="请输入手机号（11位数字）"
              value={formData.phone}
              onChange={handleChange}
              maxLength={11}
            />
            {errors.phone && (
              <span className="error-msg">{errors.phone}</span>
            )}
          </div>

          <div className={`form-group ${errors.address ? 'has-error' : ''}`}>
            <label htmlFor="address">
              详细地址 <span className="required">*</span>
            </label>
            <textarea
              id="address"
              name="address"
              placeholder="请输入详细收货地址（省市区街道门牌号）"
              value={formData.address}
              onChange={handleChange}
              minLength={10}
              maxLength={200}
              rows={4}
            />
            {errors.address && (
              <span className="error-msg">{errors.address}</span>
            )}
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              取消
            </button>
            <button
              type="submit"
              className="submit-btn"
            >
              确认下单
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default OrderAddressModal;
